// extracted by mini-css-extract-plugin
export default {"main":"AllComments_main__UTjYW","card":"AllComments_card__Wslqm","name":"AllComments_name__3oqJb","datetime":"AllComments_datetime__PTEr9","comment":"AllComments_comment__y9w3W"};